import { ChangeEvent } from 'react'
import { DraggableData } from 'react-draggable'

export interface Column {
  clickable?: boolean
  defaultDateFormat?: string
  disabled?: boolean
  formatter?: ColumnFormatter
  inputType?: InputType
  isVisible?: boolean
  label?: string
  options?: SelectOptionConfig[]
  placeholder?: string
  resizable?: boolean
  sort?: SortType | ((columnKey: string) => ColumnSorter)
  sortable?: boolean
  value?: string
  width: number
  filter?: ColumnFilter
}

export type ColumnFilter = ColumnFilterFunction | FilterType

export interface CheckboxItem {
  key: string
  label?: string
  checked?: boolean
}

export interface ColumnFormatter {
  (val: string | Record<string, string>, rowIndex: number): string | JSX.Element
}

export interface ColumnSet extends Record<string, Column> {}

export interface ColumnSorter {
  (a: Row, b: Row): number
}

interface ColumnFilterFunction {
  (key: string, value: string): (datum: any) => boolean
}

export interface FilterConfig {
  type: string
  onChange: (event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void
  value: string
  disabled?: boolean
  options?: SelectOptionConfig[]
  placeholder?: string
  clear?: (columnKey: string) => void
}

export enum FilterType {
  Text = 'text',
  Exact = 'exact'
}

export interface FilterState {
  filter?: ColumnFilter
  value: string
}

export interface FilterStateSet extends Record<string, FilterState> {}

export enum InputType {
  Select = 'select',
  Input = 'input'
}

export interface SelectOptionConfig {
  label: string
  value: string
}

export interface ResizeInfo {
  columnKey: string
  data: DraggableData
}

export interface Row extends Record<string, string | Record<string, string>> {}

export interface ShowHideColumnsConfig {
  localStorageNamespace: string
  menuTitle: string | JSX.Element
  menuWrapper: () => JSX.Element
}

export interface SortIconsConfig {
  ascending: JSX.Element
  descending: JSX.Element
}

export interface SortState {
  ascending: boolean
  column: string
}

export enum SortType {
  Date = 'date'
}
